import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptorInstance from './axiosInterceptorInstance';
import { GetVehicleMakeRequest } from '@/types/Vehicle/VehicleMake';
import { GetVehicleModelRequest } from '@/types/Vehicle/VehicleModel';
import { getCountryCode } from '@/helpers/CountryCodeHelper';
import { GetVehicleYearRequest } from '@/types/Vehicle/VehicleYear';
import { GetVehicleVariantRequest } from '@/types/Vehicle/VehicleVariant';


export const getVehicleMake = createAsyncThunk(
  'masterVehicle/getVehicleMake',
  async (payload: GetVehicleMakeRequest) => {
    try {
      const request: GetVehicleMakeRequest = {
        classCode: payload.classCode,
        countryCode: getCountryCode(),
      };
      const relativeUrl = `MasterVehicle/MakeList`;
      const apiUrl = `/quote/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const getVehicleModel = createAsyncThunk(
  'masterVehicle/getVehicleModel',
  async (payload: GetVehicleModelRequest) => {
    try {
      const request: GetVehicleModelRequest = {
        classCode: payload.classCode,
        makeCode: payload.makeCode,
        countryCode: getCountryCode(),
      };
      const relativeUrl = `MasterVehicle/ModelList`;
      const apiUrl = `/quote/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const getVehicleYear = createAsyncThunk(
  'masterVehicle/getVehicleYear',
  async (payload: GetVehicleYearRequest) => {
    try {
      const request: GetVehicleYearRequest = {
        classCode: payload.classCode,
        makeCode: payload.makeCode,
        modelCode: payload.modelCode,
        countryCode: getCountryCode(),
      };
      const relativeUrl = `MasterVehicle/YearList`;
      const apiUrl = `/quote/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const getVehicleVariant = createAsyncThunk(
  'masterVehicle/getVehicleVariant',
  async (payload: GetVehicleVariantRequest) => {
    try {
      const request: GetVehicleVariantRequest = {
        classCode: payload.classCode,
        makeCode: payload.makeCode,
        modelCode: payload.modelCode,
        year: payload.year,
        countryCode: getCountryCode(),
      };
      const relativeUrl = `MasterVehicle/VariantList`;
      const apiUrl = `/quote/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);